import { useEffect } from "react";
import { logOut } from "./api/client";
import GlobalStyle from "./globalStyle";
import authStorage from "./utils/authStorage";
import userStorage from "./utils/userStorage";
import { AxiosError } from "axios";
import { CustomAxiosError } from "./types/types";
import { useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { Outlet } from "react-router-dom";
import { useWindowSize } from "@reactuses/core";
import { I18nProvider, loadLocale } from "./locales";

// 전역 오류 등록
declare module "@tanstack/react-query" {
  interface Register {
    defaultError: AxiosError<CustomAxiosError>;
  }
}

function App() {
  const { enqueueSnackbar } = useSnackbar();
  const { height } = useWindowSize();
  const channel = new BroadcastChannel("sw-messages");
  channel.addEventListener("message", (event) => {
    if (event.data.title === "logout") {
      logOut();
    }
  });
  const user = userStorage.get();
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.setDefaultOptions({
      queries: {
        retry: false,
      },
      mutations: {
        retry: false,
        onError: (error) => {
          // console.log(error);
          if (error.response) {
            if (error.response.data.code !== 4001) {
              enqueueSnackbar(error.response.data.message, {
                variant: "error",
              });
            }
            return;
          } else {
            enqueueSnackbar("잠시 후에 다시 시도해 주세요.", {
              variant: "error",
            });
          }
          return error;
        },
      },
    });
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      if (event.currentTarget !== window) {
        if (user?.keepLoggedIn === false) {
          authStorage.clear();
          userStorage.clear();
          window.location.replace("/login");
        }
      }
      // 새로고침 시 얼럿 표출
      // else if (event.currentTarget === window) {
      //   event.preventDefault();
      // }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [user?.keepLoggedIn, user]);

  useEffect(() => {
    let vh = 0;
    vh = height * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }, [height]);

  //  console.log(user?.keepLoggedIn);
  return (
    <I18nProvider defaultLocale={loadLocale()}>
      <div className="App">
        <GlobalStyle />
        <Outlet />
      </div>
    </I18nProvider>
  );
}

export default App;
